/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersDetailsQuery } from '../../models/get-orders-details-query';
import { GetOrdersDetailsQueryResult } from '../../models/get-orders-details-query-result';

export interface ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Params {
      body?: GetOrdersDetailsQuery
}

export function apiNurseryManagerOrderDetailsGetOrdersDetailsPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsGetOrdersDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsGetOrdersDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersDetailsQueryResult>;
    })
  );
}

apiNurseryManagerOrderDetailsGetOrdersDetailsPost.PATH = '/api/NurseryManager/OrderDetails/GetOrdersDetails';
